// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  max-height: 100vh;
  overflow: auto;
}

.container {
  width: 100%;
  padding: 20px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0px;
  background: transparent;
  height: 60px;
}
.header .icon_wrapper ion-icon {
  height: 10px;
  width: 10px;
  rotate: 180deg;
  transition: rotate 0.5s;
  margin-left: 10px;
}
.header .icon_wrapper ion-icon.isOpen {
  rotate: 0deg;
}

.button {
  width: 100%;
  padding: 10px;
  margin-top: 20px;
}
.button .close {
  background: var(--ion-color-primary);
  text-align: center;
  border-radius: 50px;
}
.button .close p {
  text-align: center;
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
  color: white !important;
}

.info-section {
  padding: 10px 0;
}
.info-section ::ng-deep * {
  text-align: left;
  font-family: AppFont, sans-serif;
  font-size: 12px;
  line-height: 18px;
  color: #1a1a18 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/allergens-info-modal/allergens-info-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;EACA,cAAA;AACD;;AAEA;EACC,WAAA;EACA,aAAA;AACD;;AAEA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;AACD;AACE;EACC,YAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;AACH;AAAG;EACC,YAAA;AAEJ;;AAIA;EACC,WAAA;EACA,aAAA;EACA,gBAAA;AADD;AAEC;EACC,oCAAA;EACA,kBAAA;EACA,mBAAA;AAAF;AACE;EACC,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,uBAAA;AACH;;AAIA;EACC,eAAA;AADD;AAGC;EACC,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AADF","sourcesContent":[":host {\n\tmax-height: 100vh;\n\toverflow: auto;\n}\n\n.container {\n\twidth: 100%;\n\tpadding: 20px;\n}\n\n.header {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 10px 0px;\n\tbackground: transparent;\n\theight: 60px;\n\t.icon_wrapper {\n\t\tion-icon {\n\t\t\theight: 10px;\n\t\t\twidth: 10px;\n\t\t\trotate: 180deg;\n\t\t\ttransition: rotate 0.5s;\n\t\t\tmargin-left: 10px;\n\t\t\t&.isOpen {\n\t\t\t\trotate: 0deg;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.button {\n\twidth: 100%;\n\tpadding: 10px;\n\tmargin-top: 20px;\n\t.close {\n\t\tbackground: var(--ion-color-primary);\n\t\ttext-align: center;\n\t\tborder-radius: 50px;\n\t\tp {\n\t\t\ttext-align: center;\n\t\t\tfont-size: 18px;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tcolor: white !important;\n\t\t}\n\t}\n}\n\n.info-section {\n\tpadding: 10px 0;\n\n\t::ng-deep * {\n\t\ttext-align: left;\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-size: 12px;\n\t\tline-height: 18px;\n\t\tcolor: #1a1a18 !important;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
